import { Link } from 'react-router-dom';

/**
 * Shared dark-mode shell for auth-style pages.
 * Dark ink background with grain + radial gradients, Cormorant ROJO
 * wordmark, and a glassy white card area for the form/content.
 *
 * Props:
 *   eyebrow:   small uppercase label above the wordmark
 *   title:     subtitle below the wordmark
 *   subtitle:  optional supporting paragraph
 *   children:  the card / form body
 *   footer:    optional element rendered below the card
 */
const AuthShell = ({ eyebrow = 'Mens Retreat · 2026', title, subtitle, children, footer }) => {
  return (
    <div className="min-h-screen relative overflow-hidden bg-[#0f0a09] text-white flex flex-col items-center justify-center px-6 py-12">
      {/* Background gradient + grain */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,rgba(239,68,68,0.18),transparent_60%),radial-gradient(ellipse_at_bottom_left,rgba(249,115,22,0.12),transparent_55%)]" />
      <div className="absolute inset-0 grain" />

      <div className="relative z-10 w-full max-w-md animate-fade-in">
        {/* Wordmark */}
        <div className="text-center mb-10 animate-slide-up">
          <Link to="/" className="inline-block">
            <p className="eyebrow text-white/40 mb-3">{eyebrow}</p>
            <h1 className="font-display text-6xl sm:text-7xl font-semibold tracking-tighter text-white leading-none">
              <span className="bg-gradient-to-br from-red-400 to-orange-400 bg-clip-text text-transparent">
                ROJO
              </span>
            </h1>
          </Link>
          {title && (
            <p className="mt-5 text-lg font-display text-white/85 tracking-tight">{title}</p>
          )}
          {subtitle && (
            <p className="mt-2 text-sm text-white/55 max-w-xs mx-auto leading-relaxed">
              {subtitle}
            </p>
          )}
        </div>

        {/* Card slot */}
        <div className="animate-slide-up-1">{children}</div>

        {/* Optional footer slot */}
        {footer && <div className="text-center mt-8 animate-slide-up-2">{footer}</div>}
      </div>
    </div>
  );
};

export default AuthShell;
